export default __webpack_public_path__ + "static/media/logo_thvl.0e8760d5.png";